/**
 * Hosts the Next image optimizer may fetch from — keep in sync with
 * `images.remotePatterns` in `next.config.js`. `next/image` throws while rendering a
 * remote url outside that list, so anything else must stay `unoptimized`.
 */
const OPTIMIZABLE_HOSTS = new Set([
  "traveladev.sgp1.digitaloceanspaces.com",
  "travelaprod.sgp1.digitaloceanspaces.com",
  "traveladev.sgp1.cdn.digitaloceanspaces.com",
  "travelaprod.sgp1.cdn.digitaloceanspaces.com",
]);

/**
 * Whether `next/image` can resize this src: a local path (`/images/…`) or an https url on
 * one of our Spaces hosts.
 */
export const isOptimizableImage = (src: string): boolean => {
  if (src.startsWith("/") && !src.startsWith("//")) return true;
  try {
    const url = new URL(src);
    return url.protocol === "https:" && OPTIMIZABLE_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
};
